import { APPMETRICA_SERVE } from '@features/apps/constants'
import { useResponsive } from '@shared/nuxt/useResponsive'

/**
 * Mobile landing `/a/`: редирект в стор по ОС устройства.
 * Вызывать из page middleware (definePageMeta работает только в app/pages).
 *
 * @returns результат `navigateTo` для мобильного устройства или `undefined`
 */
export const useMobileToStoreRedirect = () => {
  const { isDesktop } = useResponsive()
  const { isAndroid, isIos } = useDevice()

  if (isDesktop.value) return

  const href = isAndroid
    ? APPMETRICA_SERVE.google
    : isIos
      ? APPMETRICA_SERVE.apple
      : APPMETRICA_SERVE.huawei

  return navigateTo(href, { external: true })
}
